module.exports = __webpack_public_path__ + "img/IMG_0803.6c91f5e4.jpeg";